/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Select_Set_PromptInputs */



/**
* | output |
* | --- |
* | "Please select a Tag Set from the menu on the left" |
*
* @param {Tags_Manager_Select_Set_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_select_set_prompt = /** @type {((inputs?: Tags_Manager_Select_Set_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Select_Set_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un ensemble de tags dans le menu de gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie links im Menü ein Tag-Set aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un set di tag dal menu a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите набор тегов из меню слева.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un conjunto de etiquetas del menú de la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请从左侧菜单中选择一个标签集。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左側のメニューからタグセットを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया बाईं ओर के मेनू से एक टैग सेट चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um conjunto de etiquetas no menu à esquerda.")
	return /** @type {LocalizedString} */ ("Please select a Tag Set from the menu on the left")
});